import React from "react";
import "./InfoSection.css";

type InfoSectionProps = {
  title: string;
  description: string;
  buttonLink: string;
};

const InfoSection: React.FC<InfoSectionProps> = ({ title, description, buttonLink }) => {
  return (
    <section className="info-section">
      <div className="info-content">
        <div className="text-wrapper">
          <h2 className="info-title">{title}</h2>
          <p className="info-description">{description}</p>
        </div>
        <a
          href={buttonLink}
          target="_blank"
          rel="noopener noreferrer"
          className="info-button"
        >
          Book a Meeting
        </a>
      </div>
    </section>
  );
};

export default InfoSection;
